import { addresses, Prisma } from '@jurnee/database/src/client';
import { Exclude, Expose } from 'class-transformer';

export const DEFAULT_UTC_TIMEZONE = 'Etc/UTC';

export type Address = addresses;

export type AddressCreate = Prisma.addressesCreateInput;

export type AddressUpdate = Prisma.addressesUncheckedUpdateInput;

export type AddressJSON = AddressEntity;

@Exclude()
export default class AddressEntity {
  @Expose() declare id: number;
  @Expose() declare additionalInformation: string | null;
  @Expose() declare street: string | null;
  @Expose() declare city: string;
  @Expose() declare country: string;
  @Expose() declare countryCode: string;
  @Expose() declare description: string | null;
  @Expose() declare lat: number | null;
  @Expose() declare long: number | null;
  @Expose() declare postalCode: string | null;
  @Expose() declare state: string | null;
  @Expose() declare timezone: string;
}